"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bank_1 = require("./bank");
const customer_1 = require("./customer");
const portfolio_1 = require("./portfolio");
const transaction_1 = require("./transaction");
const cms_1 = require("./cms");
const fund_1 = require("./fund");
const account_1 = require("./account");
const CurrentCustomer_1 = require("./utilities/CurrentCustomer");
const business = {
    currentCustomer: CurrentCustomer_1.currentCustomer,
    customer: customer_1.customerService,
    bank: bank_1.bankService,
    transaction: transaction_1.transactionService,
    portfolio: portfolio_1.portfolioService,
    cms: cms_1.cmsService,
    fund: fund_1.fundsService,
    account: account_1.accountService,
};
exports.default = business;
//# sourceMappingURL=index.js.map